import { render, staticRenderFns } from "./BookStatusBookmark.vue?vue&type=template&id=f9c9ebd2&scoped=true&"
import script from "./BookStatusBookmark.vue?vue&type=script&lang=ts&"
export * from "./BookStatusBookmark.vue?vue&type=script&lang=ts&"
import style0 from "./BookStatusBookmark.vue?vue&type=style&index=0&id=f9c9ebd2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9c9ebd2",
  null
  
)

export default component.exports